import { eocCommonResources } from '@atlassian/eoc-resources';
import { resources as scheduleCommonResources } from '@atlassian/eoc-schedule-common/resources';

const resources = [...scheduleCommonResources, ...eocCommonResources()];

export { resources };
